import { baseApi } from "./baseApi";

const pipelineApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPipeline: builder.query({
      query: () => ({
        url: "/pipeline",
        method: "GET",
      }),
      providesTags: ["Pipeline"],
    }),
  }),
});

export default pipelineApi;
